<template>
  <div id="myChart" :style="{ width: '80vw', height: '250px' }"></div>
</template>

<script>
export default {
  props: ["respCurList1", "respPreList1"],
  data() {
    return {
      respPreList: [], //折线图去年数据
      respCurList: [], // 折线图今年数据
    };
  },
  methods: {
     drawLine(){
      let curYear = new Date().getFullYear()
      let lastYear = curYear -1
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      let option = {
        color:['#31D493','#2A8CF1'],
        legend: {
          icon:"circle",
          data:[lastYear.toString()+'年', curYear.toString()+'年'],
          right:5
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月','八月', '九月', '十月', '十一月', '十二月']
        },
        yAxis: {
          name: '(万元)',
          type: 'value',
          scale: true,
          axisLabel: {
            margin: 2,
            formatter: function (value, index) {
                if (value >= 10000 && value < 10000000) {
                    value = value / 10000 + "万";
                } else if (value >= 10000000) {
                    value = value / 10000000 + "千万";
                }
                return value;
            }
        },
        },
        series: [{
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#B4F0D8'
            }, {
              offset: 1,
              color: '#FFFFFF'
            }])
          },
          name: lastYear.toString()+'年',
          data: this.respPreList,
          type: 'line',
          smooth: true,
          symbolSize: 1,   //设定实心点的大小
          itemStyle: {
            borderColor:'#31D493'
          }
        },
          {
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#92C4F8'
              }, {
                offset: 1,
                color: '#FFFFFF'
              }])
            },
            name: curYear.toString()+'年',
            data: this.respCurList,
            type: 'line',
            smooth: true,
            symbolSize: 1,   //设定实心点的大小
            itemStyle: {
              borderColor:'#2A8CF1'
            }
          }]
      };
      myChart.setOption(option);
    },
  },
  watch: {
    respCurList1(newvalue, oldvalue) {
      this.respCurList = newvalue;
      this.drawLine();
    },
    respPreList1(newvalue, oldvalue) {
      this.respPreList = newvalue;
      this.drawLine();
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
.line {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/operationSummary/components/lineChart.vue